export default __webpack_public_path__ + "static/media/2442.ca05e3a0.png";